import { getOffer, getUsers, changeStatus } from "@/api/offer";
import Vue from "vue";

const state = {
  data: {},
  users: {},
  status: "",
};

const mutations = {
  SET_DATA(state, data) {
    state.data = data;
  },
  SET_USERS(state, users) {
    state.users = users;
  },
  SET_STATUS(state, status) {
    state.status = status;
  },
};

const actions = {
  async getOffer({ commit }, payload) {
    try {
      const response = await getOffer(payload);
      if (response && response.code === 200 && response.data) {
        commit("SET_DATA", response.data);
        commit("SET_STATUS", response.data.status);
        return response;
      } else {
        throw response.message;
      }
    } catch (e) {
      Vue.$toast.error(e, {
        duration: 0,
      });
    }
  },
  async getUsers({ commit }, payload) {
    try {
      const response = await getUsers(payload);
      if (response && response.code === 200 && response.data) {
        commit("SET_USERS", response.data);
        return response;
      } else {
        throw response.message;
      }
    } catch (e) {
      Vue.$toast.error(e, {
        duration: 0,
      });
    }
  },
  async changeStatus({ dispatch, commit }, payload) {
    try {
      dispatch("loader/setLoader", true, { root: true });
      const response = await changeStatus(payload);
      if (response && response.code === 200 && response.data) {
        Vue.$toast.success("Status updated successfully");
        commit("SET_STATUS", response?.data?.status);
        return response;
      } else {
        throw response.message;
      }
    } catch (e) {
      Vue.$toast.error(e, {
        duration: 0,
      });
    } finally {
      dispatch("loader/setLoader", false, { root: true });
    }
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
